import { WriteTransaction } from 'replicache'
import { Bookmark, bookmarkBaseOps } from '@basehub/data/replicache/index'
import { invariant } from '@epic-web/invariant'

async function createBookmark(
  tx: WriteTransaction,
  data: Bookmark
): Promise<void> {
  await bookmarkBaseOps.put(tx, data)
}

async function deleteBookmark(
  tx: WriteTransaction,
  id: string
): Promise<Bookmark> {
  const bookmark = await bookmarkBaseOps.get(tx, id)
  invariant(bookmark, `Bookmark ${id} not found.`)
  await bookmarkBaseOps.delete(tx, id)
  return bookmark
}

export const bookmarkMutators = {
  createBookmark,
  listBookmarks: bookmarkBaseOps.list,
  deleteBookmark,
}
